import React from "react";
import "./styles.scss";
import { Dropdown } from "react-bootstrap";

export default ({ meta, page, pageSize, changePage, changePageSize }) => 
 meta && meta.count && meta.count > 10 ? (
    <div id="hudl-pagination" className="d-flex justify-content-between my-5 text-uppercase text-secondary font-weight-bold">
      <Dropdown id="pagination-dropdown" drop="up">
        <Dropdown.Toggle
          as={React.forwardRef((props, ref) => (
            <div {...props} ref={ref} style={{ cursor: "pointer" }}>
              page {page + 1}
            </div>
          ))}
        />
        <Dropdown.Menu>
          {Array(Math.ceil(meta.count / pageSize))
            .fill(0)
            .map((o, i) => (
              <Dropdown.Item
                key={i}
                onClick={() => {
                  changePage(i);
                }}
              >
                <div>{`Page ${i + 1}`}</div>
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
      <div>
        <button
          className="btn text-secondary"
          disabled={!page}
          onClick={() => {
            changePage(page - 1);
          }}
        >
          {"<"}
        </button>
        {` ${page + 1} / ${Math.ceil(meta.count / pageSize)} `}
        <button
          className="btn text-secondary"
          disabled={page + 1 === Math.ceil(meta.count / pageSize)}
          onClick={() => {
            changePage(page + 1);
          }}
        >
          {">"}
        </button>
      </div>
      <div>
        <span>view</span>
        <button
          className="btn text-secondary"
          onClick={() => {
            changePageSize(10);
          }}
        >
          10
        </button>
        <button
          disabled={meta.count < 20}
          className={`btn text-secondary ${meta.count < 20 ? "disabled" : ""}`}
          onClick={() => {
            changePageSize(20);
          }}
        >
          20
        </button>
        <button
          disabled={meta.count < 80}
          className={`btn text-secondary ${meta.count < 80 ? "disabled" : ""}`}
          onClick={() => {
            changePageSize(80);
          }}
        >
          80
        </button>
      </div>
    </div>
  ) : null;
